import {requestCdrByPost} from '../../util/request'
import {CDRAPI} from '@/util/cdrapi'
import reqwest from 'reqwest'
import {cdrRequestUrl} from '@/config/project-config'
import Vue from 'vue'
import store from '../../store'
import md5 from 'js-md5';
var qs = require('qs');
/**
 * AI报价模块
 */
export default {
  namespaced: true,
  state: {
    // 这里放全局参数
  },
  getters: {
    // 这里放get方法 this.$store.getters['company/getMenus']
    getCdrImageUrlHeader () {
      return cdrRequestUrl + CDRAPI.imageResource
    }
  },
  mutations: {
    // 这里是set方法  this.$store.commit('setDemoValue', value);
  },
  actions: {
    //这里定义异步请求函数
    uploadCdrFile(e, formData) {
      Vue.$vux.loading.show({
          text: '加载中...'
      })
      return new Promise((resolve, reject) => {
        let timestamp = new Date().getTime() + '';
        let radom = Math.random() + '';
        let crossType = 1;
        var str = timestamp + radom + crossType
        let token = md5(str)
        return reqwest({
          url: cdrRequestUrl + CDRAPI.uploadCdrFile,
          method: 'post',
          processData: false,
          data: formData,
          type: 'json',
          headers: {		//请求头的信息
            'Access-Control-Allow-Origin': '*',
            'timestamp': timestamp,
            'radom': radom,
            'crossType': crossType,
            'crossToken': token
          },
          success: (res) => {
            Vue.$vux.loading.hide();
            resolve(res)
          },
          error: err => {
            Vue.$vux.loading.hide();
            reject(err)
          }
        })
      })
    },
    fnLoadCdrFileDemo (e, param) {
      return requestCdrByPost(cdrRequestUrl + CDRAPI.loadCdrFileDemo, param, 0, 1, 1)
    },
    resetCdrFile (e, param) {
      return requestCdrByPost(CDRAPI.resetCdrFile, param, 0, 1)
    },
    groupShapes (e, param) {
      return requestCdrByPost(CDRAPI.groupShapes, param, 0, 1)
    },
    combineShapes (e, param) {
      return requestCdrByPost(CDRAPI.combineShapes, param, 0, 1)
    },
    smartCombine (e, param) {
      return requestCdrByPost(CDRAPI.smartCombine, param, 0, 1)
    },
    breakApart (e, param) {
      return requestCdrByPost(CDRAPI.breakApart, param, 0, 1)
    },
    convertToCurves (e, param) {
      return requestCdrByPost(CDRAPI.convertToCurves, param, 0, 1)
    },
    reloadCdrFile (e, param) {
      return requestCdrByPost(CDRAPI.reloadCdrFile, param, 0, 1)
    },
    DoAnalysis (e, param) {
      return requestCdrByPost(CDRAPI.DoAnalysis, param, 0, 1)
    },
    testCdrCors (e, param) {
      Vue.$vux.loading.show({
          text: '加载中...'
      })
      console.log('testCdrCors param ===>', param)
      return new Promise((resolve, reject) => {
        return reqwest({
          url: 'http://localhost:56412/analysis/DoAnalysis',
          method: 'post',
          processData: false,
          data: qs.stringify(param),
          type: 'json',
          headers: {		//请求头的信息
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            'Access-Control-Allow-Origin': '*',
            'token': store.getters.getToken
          },
          success: (res) => {
            Vue.$vux.loading.hide();
            resolve(res)
          },
          error: err => {
            Vue.$vux.loading.hide();
            reject(err)
          }
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/cdr.js